export default __webpack_public_path__ + "static/1-6228101fcadd1b35730739bde0a80b99.jpg";